var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark--filled_1_",
    "data-name": "checkmark--filled (1)",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21041",
    "data-name": "Path 21041",
    d: "M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8ZM8.857,13.195,6,10.338l.909-.909,1.948,1.948,4.234-4.234L14,8.049Z",
    fill: "#368a04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "inner-path",
    d: "M11.857,17.052,9,14.195l.909-.909,1.948,1.948L16.091,11l.911.906Z",
    transform: "translate(-3 -3.857)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon);
export default __webpack_public_path__ + "static/media/ApproveIcon.e0700c580a192bb3d75111da5f83afad.svg";
export { ForwardRef as ReactComponent };